import { render, staticRenderFns } from "./OrdersDealer.vue?vue&type=template&id=693e138e&"
import script from "./OrdersDealer.vue?vue&type=script&lang=js&"
export * from "./OrdersDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports